import { defineStore } from 'pinia'

import * as accessaryFormApi from '../services/api/accessary-form'
import { IApproval } from './staff'

export interface IAccessaryData {
  quote_line_id?: number
  name: string
  sku: string
  quantity: number
  unit: string
  has_received: boolean
}

export interface IAccessaryFormData {
  id: number
  type: string
  status: string
  note: string
  reason: string
  approvals: Array<IApproval>
  accessaries: Array<IAccessaryData>
  creator_id: number
  car_id: number
  creator: any
  car: any
  created_at: string
}

export const useAccessaryFormStore = defineStore('AccessaryForm', {
  state: () => ({
    isLoading: true,
    accessaryForm: {
      id: 0,
      type: '',
      status: '',
      note: '',
      reason: '',
      approvals: [],
      accessaries: [],
      creator_id: 0,
      car_id: 0,
      creator: {},
      car: {},
      created_at: '',
    } as IAccessaryFormData,
    accessaryForms: [] as IAccessaryFormData[],
    count: 0,
  }),
  actions: {
    setAccessaryForm(data: IAccessaryFormData) {
      this.accessaryForm = data
    },
    setAccessaryForms(data: IAccessaryFormData[]) {
      this.accessaryForms = data
    },
    setCount(data: number) {
      this.count = data
    },
    setLoading(value: boolean) {
      this.isLoading = value
    },
    addAccessaryForm(data: IAccessaryFormData) {
      this.accessaryForms.push(data)
    },
    async getAccessaryFormDetail(id: number) {
      try {
        const { data } = await accessaryFormApi.get(id)
        this.setAccessaryForm(data)
        return data
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async updateAccessaryForm(payload: any) {
      try {
        const { data } = await accessaryFormApi.update(this.accessaryForm.id, payload)
        this.setAccessaryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async applyAccessaryForm() {
      try {
        const { data } = await accessaryFormApi.apply(this.accessaryForm.id)
        this.setAccessaryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async rejectAccessaryForm(payload: any) {
      try {
        const { data } = await accessaryFormApi.reject(this.accessaryForm.id, payload)
        this.setAccessaryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async remakeAccessaryForm(payload: any) {
      try {
        const { data } = await accessaryFormApi.remake(this.accessaryForm.id, payload)
        this.setAccessaryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async approveAccessaryForm(payload: any) {
      try {
        const { data } = await accessaryFormApi.approve(this.accessaryForm.id, payload)
        this.setAccessaryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async completeAccessaryForm(payload: any) {
      try {
        const { data } = await accessaryFormApi.complete(this.accessaryForm.id, payload)
        this.setAccessaryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async countAccessaryForms() {
      try {
        const { data } = await accessaryFormApi.count()
        this.setCount(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async createAccessaryForm(payload: any) {
      try {
        const { data } = await accessaryFormApi.create(payload)
        this.addAccessaryForm(data)
        return data
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listAccessaryForms(params?: any) {
      try {
        this.setLoading(true)
        const result = await accessaryFormApi.list(params)
        const { data, total } = result as any
        this.setAccessaryForms(data)
        this.setLoading(false)
        return { data, total }
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listAllAccessaryForms(params?: any) {
      try {
        this.setLoading(true)
        const result = await accessaryFormApi.listAll(params)
        const { data, total } = result as any
        this.setAccessaryForms(data)
        this.setLoading(false)
        return { data, total }
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
  },
})
